import { render, staticRenderFns } from "./GroupEditor.vue?vue&type=template&id=c3bd54b8&scoped=true"
import script from "./GroupEditor.vue?vue&type=script&lang=js"
export * from "./GroupEditor.vue?vue&type=script&lang=js"
import style0 from "./GroupEditor.vue?vue&type=style&index=0&id=c3bd54b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bd54b8",
  null
  
)

export default component.exports